<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header"
         style="cursor: pointer;"
         (click)="expandOrCollapse()"
         [ngClass]="{'disable-pointer-events': !hasViewPermission}">
        <panel-chevron [showBody]="showBody"></panel-chevron>
        <h3>Invoices</h3>
    </div>
    @if (showBody) {
        <div class="card-body" style="padding-top: 0;">
            @if (!siteId) {
                <div style="float: right;">
                    <label style="position: relative; margin-right: 4px;">RIBS Due Date Range: </label>
                    <div class="input-group" style="display:inline-block; width: 138px; margin-top: 12px;">
                        <weissman-datetime [(inputDate)]="fromDate"
                                           [dateOnly]="true"
                                           [timeZone]="'Central'"
                                           #startDatePicker>
                        </weissman-datetime>
                    </div>
                    <span style="margin: 0 6px; position: relative;">to</span>
                    <div class="input-group" style="display:inline-block; width: 138px; margin-top: 12px;">
                        <weissman-datetime [(inputDate)]="toDate"
                                           [dateOnly]="true"
                                           [timeZone]="'Central'"
                                           [rangeEnd]="true"
                                           #endDatePicker>
                        </weissman-datetime>
                    </div>
                    <button class="ace-btn btn-sm btn-primary"
                            (click)="loadPanel()">
                        Refresh
                    </button>
                </div>
            }
            @if (isLoading) {
                <div class="text-center" style="margin-top: 50px;">
                    <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                </div>
            }
            @if (!isLoading) {
                <div style="clear: right;">
                    <!--Dima: scrollable table, implemented based on samples from http://salzerdesign.com/test/fixedTable.html-->
                    <div class="fixed-table-container hidden-head">
                        <div class="header-background"></div>
                        <div class="fixed-table-container-inner">
                            <table class="table table-condensed table-hover">
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="th-inner">RIBS Due Date</div>
                                        </th>
                                        @if (!siteId && showSiteColumn) {
                                            <th>
                                                <div class="th-inner">Site</div>
                                            </th>
                                        }
                                        <th>
                                            <div class="th-inner">Contract Type</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">Tax Year</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">RIBS Request #</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">Invoice Amt</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">Status</div>
                                        </th>
                                    </tr>
                                    <tr class="hidden-header">
                                        <th>
                                            <div class="th-inner">RIBS Due Date</div>
                                        </th>
                                        @if (!siteId && showSiteColumn) {
                                            <th>
                                                <div class="th-inner">Site</div>
                                            </th>
                                        }
                                        <th>
                                            <div class="th-inner">Contract Type</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">Tax Year</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">RIBS Request #</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">Invoice Amt</div>
                                        </th>
                                        <th>
                                            <div class="th-inner">Status</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style="overflow-y: scroll">
                                    @for (invoice of this.invoices; track invoice) {
                                        <tr class="pointer" (click)="rowSelected(invoice)">
                                            @if (!invoice.dueDate) {
                                                <td></td>
                                            }
                                            @if (invoice.dueDate) {
                                                <td>{{ invoice.dueDate | weissmanDateFormat }}</td>
                                            }
                                            @if (!siteId && showSiteColumn) {
                                                <td>{{ invoice.siteName }}</td>
                                            }
                                            <td>
                                                {{ invoiceService.contractServiceName(invoice.contractServiceType) }}
                                                @if (invoice.contractServiceType == ContractServiceType.Appeal && invoice.isAdHoc) {
                                                    <span> (ad hoc)</span>
                                                }
                                            </td>
                                            <td>{{ invoice.annualYear }}</td>
                                            <td>{{ invoice.invoiceNumber ? invoice.invoiceNumber : 'Draft' }}</td>
                                            <td>{{ invoice.invoiceAmount | currency:'USD' }}</td>
                                            <td>
                                                <div>
                                                    <a style="cursor:pointer"
                                                       (click)="launchTaskModal($event, invoice)">{{ invoice.taskSummary[0] ? invoice.taskSummary[0].status : '' }}</a>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div style="display: flex; gap: 5px;">
                        @if (!creatingAdminInvoices && allowEdit && !editLock) {
                            <button class="ace-btn btn-primary" (click)="createAdHocInvoice()">Create Invoice</button>
                        }
                        @if (siteId && allowEdit && !editLock && parcelsReadyForInvoiceCount) {
                            <button class="ace-btn btn-primary" (click)="createInvoices()">
                                Invoice {{ parcelsReadyForInvoiceCount }} Parcel Invoice Appeal Savings Task(s)
                            </button>
                        }
                        @if (!siteId && allowEdit && !editLock && !creatingAdminInvoices && sitesReadyForInvoiceCount) {
                            <button class="ace-btn btn-primary" (click)="startCreateAdminInvoices()">Create Site Admin
                                Fee Invoices
                            </button>
                        }
                    </div>
                    @if (creatingAdminInvoices) {
                        <div>
                            <label style="margin-right:1em;margin-left:0.5em;">
                                <span>Annual Year:</span>
                                <select [(ngModel)]="annualYear">
                                    @for (item of years; track item) {
                                        <option>{{ item }}</option>
                                    }
                                </select>
                            </label>
                            <button class="ace-btn btn-sm btn-primary" (click)="createAdminInvoices()">Create</button>
                            <button class="ace-btn btn-sm btn-primary btn-danger" (click)="cancelCreateAdminInvoices()">
                                Cancel
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
